import React from 'react';
import classNames from 'classnames/bind';
import { withTranslation } from 'react-i18next';

import ClickOutside from '../_ui/ClickOutside';
import IconSettings from './icons/IconSettings';
import NumberSwitcher from './NumberSwitcher';
import styles from './Settings.scss';
import config from '../../config';

const cx = classNames.bind(styles);

/**
* Стандартный компонент для настроек таблицы
*/

// const propTypes = {
//   settings: React.PropTypes.object.isRequired,
//   handleChangeSettings: React.PropTypes.func.isRequired,
// };

class Settings extends React.Component {
  state = {
    isOpen: false,
  };

  toggleDropdown = (e) => {
    e.preventDefault();
    const { isOpen } = this.state;
    this.setState({
      isOpen: !isOpen,
    });
  }

  collapse = () => {
    this.setState({
      isOpen: false,
    });
  }

  renderContent = () => {
    const { settings, handleChangeSettings, t } = this.props;
    const keys = Object.keys(settings);
    const controls = keys.map((key) => {
      if (key === 'rows') {
        return (
          <NumberSwitcher
            key={key}
            title={t('settings_dropdown_lines_number_label')}
            data={config.perPageItemsVars}
            current={settings[key]}
            name="rows"
            handleChange={handleChangeSettings}
          />
        );
      }
      return null;
    });

    return (
      <div className={styles.content}>{controls}</div>
    );
  }

  render() {
    const { isOpen } = this.state;
    return (
      <ClickOutside className={styles.main} onClickOutside={this.collapse}>
        <a href="dropdown" onClick={this.toggleDropdown} className={styles.button}>
          <IconSettings className={cx({ icon: true, active: isOpen })} />
        </a>
        {isOpen && this.renderContent()}
      </ClickOutside>
    );
  }
}

// Settings.propTypes = propTypes;
export default withTranslation('ui')(Settings);
